module.exports = __webpack_public_path__ + "img/payroll-selected.43985ea2.svg";